import { jsxs as k, jsx as n, Fragment as ie } from "react/jsx-runtime";
import A, { useRef as S, useEffect as M, useContext as _e, createContext as De, useState as I, useMemo as se, useCallback as Le } from "react";
import { u } from "./index-6a632112.mjs";
import { r as _, s as a, b as te, d as G, a as q, l as Ne, e as j, c as Ie, f as Te } from "./themes-5f0b3c3d.mjs";
import { f as We } from "./fontWeights-a25f8f91.mjs";
import { z as ze } from "./zIndices-d07533f3.mjs";
import { l as ce } from "./lineHeights-72d3110c.mjs";
import { useAccessibilityProps as Q } from "./accessibility.js";
import { Radio as Ue } from "./radio.js";
import { Checkbox as be, CheckboxStateValues as de } from "./checkbox.js";
import { S as ue } from "./types-b577bf77.mjs";
import { Ellipses as Ke } from "./menu.js";
import { u as Re } from "./uniqueId-321287e8.mjs";
import { TextInput as Pe } from "./textInput.js";
import { g as X } from "./getElementPosition-5026bb28.mjs";
import { useWindowDimensions as Be } from "./useWindowDimensions.js";
function He({
  title: e,
  titleId: r,
  size: i,
  height: $,
  width: s,
  ...v
}) {
  const d = i ? ue[i] : ue.s;
  return /* @__PURE__ */ k(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: i ? d : $ || d,
      width: i ? d : s || d,
      "aria-labelledby": r,
      ...v,
      children: [
        e ? /* @__PURE__ */ n("title", { id: r, children: e }) : null,
        /* @__PURE__ */ n("g", { clipPath: "url(#Search_svg__a)", children: /* @__PURE__ */ n(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M64.26 58.14c.72.72.72 1.8 0 2.52s-1.8.72-2.52 0L46.8 45.72c-3.96 3.24-9.18 5.04-14.76 4.5-9-.9-16.38-8.1-17.46-17.1-1.62-12.96 9.18-23.76 22.32-22.14 9 1.08 16.2 8.46 17.1 17.46.54 5.58-1.26 10.8-4.5 14.76l14.76 14.94ZM34.2 14.4c-9 0-16.2 7.2-16.2 16.2s7.2 16.2 16.2 16.2 16.2-7.2 16.2-16.2-7.2-16.2-16.2-16.2Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", { id: "Search_svg__a", children: /* @__PURE__ */ n("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const qe = u.li`
  border-radius: ${_["2x"]};
  background-color: ${(e) => e.theme.components.dropdownMenu.listItemBackgroundColor};
  margin: 0 ${a["2x"]};
  order: ${({ $itemOrder: e }) => e};

  &:hover:not([disabled]) {
    background-color: ${(e) => e.theme.components.dropdownMenu.listItemHoverColor};
  }

  &:focus-visible:not([disabled]) {
    outline: ${te["2x"]} solid
      ${(e) => e.theme.components.dropdownMenu.focusColor};
    border-radius: ${_["2x"]};
  }

  ${(e) => {
  if (e.disabled)
    return "&:focus-visible { outline: none; }";
}};

  &&.hide {
    display: none;
  }
`, je = u.button`
  all: unset;
  width: 100%;
  display: flex;
  padding: ${a["2x"]};
  box-sizing: border-box;
  word-wrap: break-word;
  align-items: flex-start;
  cursor: ${({ disabled: e }) => e ? "auto" : "pointer"};
  color: ${({ disabled: e, theme: r }) => e ? r.components.dropdownMenu.textColorDisabled : r.components.dropdownMenu.contentColor};
  font-family: ${G.body};
  font-size: ${q.xsmall};
  line-height: ${ce.small};
  font-style: normal;
  letter-spacing: ${Ne[0]};
  font-weight: ${j.regular.L.fontWeight};
  .title {
    color: ${({ disabled: e, theme: r }) => e ? r.components.dropdownMenu.textColorDisabled : r.components.dropdownMenu.textColor};
    font-family: ${G.body};
    font-size: ${q.small};
    line-height: ${ce.medium};
    font-style: normal;
    font-weight: ${j.regular.L.fontWeight};
  }
`, pe = u.div`
  display: flex;
  align-items: center;
  color: ${({ disabled: e, theme: r }) => e ? r.components.dropdownMenu.textColorDisabled : r.components.dropdownMenu.contentColor};
  img {
    width: ${a["6x"]};
    height: ${a["6x"]};
  }
  ${({ $type: e }) => `padding-right: ${e === "radio" ? "0" : a["3x"]};`}
  .radio-section {
    pointer-events: none;
  }
`, Ve = u.div`
  display: inline;
  color: ${({ disabled: e, theme: r }) => e ? r.components.dropdownMenu.textColorDisabled : r.components.dropdownMenu.contentColor};
  margin-left: auto;
  padding-left: ${a["3x"]};
  img {
    width: ${a["6x"]};
    height: ${a["6x"]};
  }
`, B = A.memo(
  ({ value: e, disable: r }) => {
    const i = S(null);
    return M(() => {
      i?.current && i.current?.querySelector('input[type="checkbox"]').setAttribute("tabindex", "-1");
    }, []), /* @__PURE__ */ n(
      "span",
      {
        className: "check-wrapper",
        "aria-hidden": "true",
        tabIndex: -1,
        style: { pointerEvents: "none" },
        ref: i,
        children: /* @__PURE__ */ n(be, { label: "", checkboxValue: e, isDisabled: r })
      }
    );
  }
), H = A.memo(
  ({ value: e, disable: r }) => {
    const i = S(null);
    return M(() => {
      i?.current && i.current?.querySelector('input[type="radio"]').setAttribute("tabindex", "-1");
    }, []), /* @__PURE__ */ n("span", { className: "radio-section", ref: i, children: /* @__PURE__ */ n(Ue, { checked: e, label: "", value: "", disabled: r }) });
  }
), Ye = {
  radio: {
    default: [
      /* @__PURE__ */ n(H, { value: !1, disable: !1 }, "radio_unchecked"),
      /* @__PURE__ */ n(H, { value: !0, disable: !1 }, "radio_checked")
    ],
    disabled: [
      /* @__PURE__ */ n(H, { value: !1, disable: !0 }, "radio_unchecked_disabled"),
      /* @__PURE__ */ n(H, { value: !0, disable: !0 }, "radio_checked_disabled")
    ]
  },
  multiple: {
    default: [
      /* @__PURE__ */ n(B, { value: 0, disable: !1 }, "box_unchecked"),
      /* @__PURE__ */ n(B, { value: 2, disable: !1 }, "box_checked")
    ],
    disabled: [
      /* @__PURE__ */ n(B, { value: 0, disable: !0 }, "box_unchecked_disabled"),
      /* @__PURE__ */ n(B, { value: 2, disable: !0 }, "box_checked_disabled")
    ]
  }
}, Fe = ({
  label: e,
  value: r,
  id: i = r,
  description: $,
  trailingElement: s,
  leadingElement: v,
  disabled: d = !1,
  className: w,
  isSelected: E = !1,
  ...V
}) => {
  const { type: C, handleSelect: g } = _e(me), Y = Q("option", {
    tabIndex: -1,
    ariaDisabled: d,
    ariaSelected: E
  });
  return /* @__PURE__ */ n(
    qe,
    {
      id: i,
      disabled: d,
      "data-value": r,
      onKeyUp: (p) => {
        (p.code === "Space" || p.code === "Enter") && (p.preventDefault(), p.stopPropagation(), g && g(p, r));
      },
      onKeyDown: (p) => {
        p.code === "Space" && (p.preventDefault(), p.stopPropagation());
      },
      className: `list-item ${C === "default" && E && !d ? "active" : ""} ${w || ""} _${oe(r)}`,
      ...Y,
      ...V,
      onClick: (p) => g(p, r),
      children: /* @__PURE__ */ k(je, { tabIndex: -1, disabled: d, children: [
        C === "default" ? v && /* @__PURE__ */ n(pe, { disabled: d, $type: C, children: v }) : /* @__PURE__ */ n(pe, { disabled: d, $type: C, children: Ye[C][d ? "disabled" : "default"][E ? 1 : 0] }),
        /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ n("div", { className: "title", children: e }),
          $
        ] }),
        s && /* @__PURE__ */ n(Ve, { disabled: d, children: s })
      ] })
    }
  );
}, he = A.memo(
  Fe,
  (e, r) => e.value === r.value && e.id === r.id && e.isSelected === r.isSelected && e.className === r.className && e.disabled === r.disabled
), Oe = "Escape", Ze = u.div`
  position: relative;
  display: inline-block;
`, Je = u.div`
  width: auto;
  &[aria-disabled='true'] {
    filter: grayscale(1);
    opacity: 0.7;
    pointer-events: none;
  }
`, Xe = u.div`
  .scroll {
    margin-right: ${a["2x"]};
  }
  display: ${({ $menuOpen: e }) => e ? "block" : "none"};
  @keyframes menuOpen {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  }
  @keyframes menuClose {
    0% {
      transform: scaleY(1);
      display: block;
    }
    99% {
      transform: scaleY(0);
      display: block;
    }
    100% {
      transform: scaleY(0);
      display: none;
    }
  }
  && {
    display: ${({ $menuOpen: e }) => e ? "block" : "none"};
    animation: ${({ $menuOpen: e }) => e ? "menuOpen" : "menuClose"}
      120ms ease-in-out forwards;
    transform-origin: ${({ $menuDirection: e }) => e.startsWith("up") ? "bottom" : "top"}
      center;
  }
  position: ${({ $exceedOverflow: e }) => e ? "fixed" : "absolute"};
  width: ${({ $exceedOverflow: e }) => e ? "max-content" : "100%"};
  z-index: ${ze.dropdown};
  box-sizing: border-box;
  min-height: ${a["12x"]};
  min-width: 280px;
  padding: ${a["2x"]} 0;
  border: ${te["1x"]} solid
    ${(e) => e.theme.components.dropdownMenu.borderColor};
  border-radius: ${_["2x"]};
  background-color: ${(e) => e.theme.components.dropdownMenu.backgroundColor};
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  ${({ $menuDirection: e }) => e === "down_right" ? {
  top: `calc(100% + ${a["2x"]})`,
  right: "0"
} : e === "up_left" ? {
  bottom: `calc(100% + ${a["2x"]})`,
  left: "0"
} : e === "up_right" ? {
  bottom: `calc(100% + ${a["2x"]})`,
  right: "0"
} : {
  top: `calc(100% + ${a["2x"]})`,
  left: "0"
}}
`, Ge = u.ul`
  list-style: none;
  padding: 2px 0;
  margin: unset;
  height: auto;

  overflow-y: auto;
  max-height: ${({ $maxItems: e }) => e * 40}px;

  ${({ $hiddenClasses: e, $searchText: r }) => e.length <= 1 || r ? `
    && > *{
      &:not(.list-item) {
        display: none;
      }
    }
  ` : ""}

  li {
    display: none;
  }
  li.${({ $hiddenClasses: e }) => e.map((r) => `_${oe(r)}`).join(", li.")} {
    display: block;
  }

  li.active.${({ $active: e }) => e} {
    background-color: ${({ theme: e }) => e.components.dropdownMenu.selectedItemBackground};
    div[type] {
      span[role='status'] {
        color: ${Ie.brandTwilight[0]};
      }
    }
    * {
      color: ${({ theme: e }) => e.components.dropdownMenu.selectedItemColor};
    }
  }

  &::-webkit-scrollbar {
    width: ${a["2x"]};
    height: ${a["1x"]};
  }

  &::-webkit-scrollbar-corner {
    background: ${(e) => e.theme.components.dropdownMenu.scrollbar.corner};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(e) => e.theme.components.dropdownMenu.scrollbar.thumb};
    border-radius: ${_["2x"]};
    transform: translateX(calc(100% - 10px));
  }

  &::-webkit-scrollbar-track {
    background-color: ${(e) => e.theme.components.dropdownMenu.scrollbar.track};
    border-radius: ${_["2x"]};
  }
`, ee = u.div`
  display: block;
  border-bottom: ${te["1x"]} solid
    ${(e) => e.theme.components.dropdownMenu.borderColor};
  margin: ${a["2x"]} 0;
`, Qe = u.div`
  color: ${({ theme: e }) => e.components.dropdownMenu.textColor};
  font-family: ${G.body};
  font-size: ${q.xxsmall};
  font-style: normal;
  font-weight: ${We.body.semibold};
  line-height: 133.33%;
  letter-spacing: 0.96px;
  text-transform: uppercase;
  padding: ${a["2x"]};
  margin: 0 ${a["2x"]};
`, et = u.div`
  width: auto;
`, tt = u.div`
  & > div {
    padding: ${a["1x"]} ${a["3x"]};
    box-sizing: border-box;
    label {
      margin: unset;
    }
    span[role='alert'] {
      margin: unset;
    }
  }
`, ot = u.div`
  padding: 0 ${a["4x"]} 0 ${a["4x"]};
  cursor: pointer;
  & > div {
    margin: ${a["1x"]};
    label {
      font-style: normal;
      font-weight: ${j.regular.L.fontWeight};
      line-height: 150%;
      color: ${(e) => e.theme.components.dropdownMenu.textColor};
    }
  }
  & div[data-component='checkbox-wrapper'] {
    &:focus-within {
      outline: 2px solid
        ${(e) => e.theme.components.dropdownMenu.focusColor};
      outline-offset: 3px;
      border-radius: ${_["2x"]};
    }
    & input[type='checkbox']:focus-visible {
      outline-color: ${(e) => e.theme.components.dropdownMenu.check};
      outline-style: solid;
      outline-width: 1px;
      outline-offset: 0px;
    }
  }
`, rt = u.div`
  display: flex;
  padding: ${a["2x"]};
  justify-content: center;
  align-items: center;
  gap: ${a["2x"]};
  align-self: stretch;
  div {
    color: ${(e) => e.theme.components.dropdownMenu.contentColor};
    text-align: center;
    font-family: ${Te.inter};
    font-size: ${q.small};
    font-style: normal;
    font-weight: ${j.regular.L.fontWeight};
    line-height: 150%;
  }
`, oe = (e) => e?.replace(/[^a-zA-Z0-9]/g, "_"), me = De({}), fe = (e, r, i) => {
  let $ = e.trimStart();
  return $ = $?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), i.length > 0 ? r.filter((s) => !i.includes(s.value)).map((s) => s.value) : r.filter(
    (s) => `${s.label}${s.value}`.search(new RegExp($, "i")) >= 0
  ).map((s) => s.value);
}, T = ({
  children: e,
  uniqueIdentifier: r,
  handleMenuOpen: i,
  onChange: $,
  type: s = "default",
  menuHeader: v = "default",
  isDisabled: d = !1,
  menuDirection: w = "down_left",
  onBlur: E,
  closeOnSelect: V,
  maxItems: C = 8,
  menuOpen: g,
  className: Y,
  noResultText: p = "No results found",
  hiddenItems: W = [],
  exceedOverflow: z = !1
}) => {
  const [U, F] = I(-1), x = S(null), c = S([]);
  c.current.callbacks = {
    onChange: $,
    onBlur: E
  };
  const ge = S(Re("dd")), f = r || ge.current, [D, re] = I(""), [K, le] = I(["menu-header"]), [O, xe] = I(!1), [$e, Z] = I({}), R = S(null), L = S(null), { width: ve, height: we } = Be(), ye = Q("region", {
    ariaHidden: !g
  }), ke = Q("listbox", {
    ariaMultiselectable: s === "multiple"
  }), ne = /* @__PURE__ */ n(Ke, { id: `control-${r}` }), Ce = se(() => {
    let t = !0;
    c.current.list = [], c.current.currentEle = !0, c.current.controlElement = ne;
    const l = A.Children.map(e, (h, y) => {
      if (h && A.isValidElement(h))
        if (h.type === T.Control)
          c.current.controlElement = h;
        else {
          if (h.type === he) {
            const m = h.props;
            c.current.list.push({
              label: m.label,
              value: m.value,
              selected: m.isSelected,
              disabled: !!m.disabled
            }), m.isSelected || (t = !1);
          }
          return h;
        }
      return null;
    });
    return xe(t), le([
      "menu-header",
      ...fe(D, c.current.list, W)
    ]), l;
  }, [e]);
  M(() => {
    le([
      "menu-header",
      ...fe(D, c.current.list, W)
    ]);
  }, [D]), M(() => {
    if (x?.current) {
      const t = document.getElementById(`list-${f}`), l = document.getElementById(`list-container-${f}`);
      t && t?.scrollHeight > t?.clientHeight ? l?.classList.add("scroll") : l?.classList.remove("scroll");
    }
  }, [e, f]);
  const P = Le(
    (t, l, h = !1) => {
      const { onChange: y, onBlur: m } = c.current.callbacks;
      if (!(t?.target?.tagName === "INPUT" && t?.target?.type !== "radio" && t?.target?.ariaLabel !== "Select All"))
        if (s === "multiple") {
          const b = [];
          h ? c.current.list.forEach((o) => {
            l && b.push({
              label: o.label,
              value: o.value,
              disabled: o.disabled
            });
          }) : c.current.list.forEach((o) => {
            o.selected ? o.value !== l && b.push({
              label: o.label,
              value: o.value,
              disabled: o.disabled
            }) : o.value === l && b.push({
              label: o.label,
              value: o.value,
              disabled: o.disabled
            });
          }), y && (Object.defineProperty(t, "target", {
            value: b
          }), t.target = { value: JSON.stringify(b) }, y(t, b)), m && m(t);
        } else {
          const b = [];
          c.current.list.forEach((o) => {
            o.value === l && b.push({ label: o.label, value: o.value });
          }), y && (Object.defineProperty(t, "target", {
            value: b?.[0]
          }), t.target = { value: JSON.stringify(b?.[0]) }, y(t, b?.[0])), m && m(t), V && N();
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), Se = se(() => ({ type: s, handleSelect: P }), [P, s]), ae = (t) => {
    let l = x.current?.querySelectorAll("li.list-item");
    const h = x.current?.querySelectorAll(
      "li.list-item:not([disabled])"
    )?.length, y = U === -1 ? 0 : U;
    if (v === "local_search" && W.length === 0) {
      const o = x?.current?.querySelector(
        `.list-item #local-search-${f}`
      );
      o && o.setAttribute("data-value", "menu-header"), l = [o, ...l];
    } else if (v === "select_all") {
      const o = x?.current?.querySelector(
        `.list-item#select-all-${f} input[type="checkbox"]`
      );
      o && o.setAttribute("data-value", "menu-header"), l = [o, ...l];
    }
    const m = () => {
      if (t?.preventDefault(), t?.stopPropagation(), h && l) {
        let o = U - 1;
        for (o < 0 && (o = l.length - 1), l[o] || (o = o - 1); (l[o].ariaDisabled !== "false" || !K.includes(
          l[o].getAttribute("data-value")
        )) && (o = o - 1, o < 0 && (o = l.length - 1), y !== o); )
          ;
        l[o]?.focus(), F(o);
      }
      return !1;
    }, b = () => {
      if (t?.preventDefault(), t?.stopPropagation(), h && l) {
        let o = U + 1;
        for (o >= l.length && (o = 0), l[o] || (o = o + 1); (l[o].ariaDisabled !== "false" || !K.includes(
          l[o].getAttribute("data-value")
        )) && (o = o + 1, o >= l.length && (o = 0), y !== o); )
          ;
        l[o]?.focus(), F(o);
      }
      return !1;
    };
    switch (t.key) {
      case Oe:
        x?.current?.querySelector(`#control-${f}`)?.focus(), t?.preventDefault(), N();
        break;
      case "Enter":
        if (t?.target?.tagName === "BUTTON" || t?.target?.ariaLabel === "Select All")
          return;
        J();
        break;
      case " ":
        if (t?.target?.ariaLabel === "Select All")
          return;
        J();
        break;
      case "ArrowUp":
        m();
        break;
      case "ArrowDown":
        b();
        break;
      default:
        return;
    }
  }, Ee = () => {
    if (s === "multiple")
      return "";
    for (let t = 0; t < c.current.list.length; t++) {
      const l = c.current.list[t];
      if (l.selected && !l.disable)
        return `_${oe(l.value)}`;
    }
  }, J = () => {
    g ? N() : Me();
  }, Me = () => {
    F(-1), re(""), c.current.currentEle = !0, i && i(!0);
  }, N = A.useCallback(() => {
    i && i(!1), x.current && c.current.currentEle && (c.current.currentEle = !1, x.current?.querySelector(
      `#control-${r}`
    )?.focus());
  }, []);
  M(() => {
    const t = (l) => {
      x.current && !x.current.contains(l.target) && g && l.target.tagName !== "svg" && (c.current.currentEle = !1, N());
    };
    return window.addEventListener("click", t), window.addEventListener("keydown", t), () => {
      window.removeEventListener("click", t), window.removeEventListener("keydown", t);
    };
  }, [g, N]), M(() => {
    if (g && z) {
      Z(X(R, L, w, "dropdown"));
      const t = () => {
        Z(
          X(R, L, w, "dropdown")
        );
      };
      window.addEventListener("scroll", t, !0);
      const l = new ResizeObserver(() => {
        Z(
          X(R, L, w, "dropdown")
        );
      });
      return l.observe(L?.current), () => {
        window.removeEventListener("scroll", t, !0), l.disconnect();
      };
    }
  }, [g, w, z, ve, we]);
  const Ae = () => {
    if (v === "local_search" && W.length === 0)
      return /* @__PURE__ */ k(ie, { children: [
        /* @__PURE__ */ n(tt, { className: "list-item", children: /* @__PURE__ */ n(
          Pe,
          {
            labelProp: {
              label: ""
            },
            id: `local-search-${f}`,
            textSize: "medium",
            placeholder: "Search...",
            value: D,
            startAdornment: /* @__PURE__ */ n(He, {}),
            onChange: (t) => {
              re(t.currentTarget.value);
            },
            onKeyUp: (t) => {
              (t?.code === "Space" || t?.code === "Enter") && (t?.preventDefault(), t?.stopPropagation());
            },
            accessibilityOptions: {
              ariaDisabled: !1
            }
          }
        ) }),
        /* @__PURE__ */ n(ee, {})
      ] });
    if (s === "multiple" && v === "select_all")
      return /* @__PURE__ */ k(ie, { children: [
        /* @__PURE__ */ n(
          ot,
          {
            className: "list-item",
            "aria-label": "Select All",
            onBlur: E,
            onClick: (t) => {
              t?.preventDefault(), t?.stopPropagation(), P(t, O ? "" : " ", !0);
            },
            onKeyDown: (t) => {
              (t?.code === "Space" || t?.code === "Enter") && (P(t, O ? "" : " ", !0), t?.preventDefault(), t?.stopPropagation());
            },
            id: `select-all-${f}`,
            children: /* @__PURE__ */ n("span", { style: { pointerEvents: "none" }, children: /* @__PURE__ */ n(
              be,
              {
                id: "select-all",
                label: "Select All",
                "aria-disabled": !1,
                checkboxValue: O ? de.CHECKED : de.UNCHECKED
              },
              "select-all"
            ) })
          },
          `select-all-${f}`
        ),
        /* @__PURE__ */ n(ee, {})
      ] });
  };
  return /* @__PURE__ */ n(me.Provider, { value: Se, children: /* @__PURE__ */ k(Ze, { ref: x, className: Y, children: [
    /* @__PURE__ */ n(
      Je,
      {
        ref: R,
        "aria-disabled": d,
        onKeyUp: (t) => {
          t?.preventDefault(), !d && ae(t);
        },
        onKeyDown: (t) => {
          if (t.key === "ArrowUp" || t.key === "ArrowDown")
            return t?.preventDefault(), t?.stopPropagation(), !1;
        },
        onClick: (t) => {
          t?.preventDefault(), !d && J();
        },
        id: `control-container-${f}`,
        children: c.current.controlElement || ne
      }
    ),
    /* @__PURE__ */ k(
      Xe,
      {
        $menuOpen: g,
        id: `content-${f}`,
        ...ye,
        $menuDirection: w,
        onKeyUp: (t) => {
          d || ae(t);
        },
        onKeyDown: (t) => {
          if (t.key === "ArrowUp" || t.key === "ArrowDown")
            return t?.preventDefault(), t?.stopPropagation(), !1;
        },
        ref: L,
        $exceedOverflow: z,
        style: z ? $e : {},
        children: [
          Ae(),
          /* @__PURE__ */ n("div", { id: `list-container-${f}`, children: /* @__PURE__ */ k(
            Ge,
            {
              $hiddenClasses: K,
              $searchText: D.trim().length > 0,
              $active: Ee(),
              $maxItems: C,
              id: `list-${f}`,
              ...ke,
              children: [
                Ce,
                K.length === 1 && /* @__PURE__ */ n(rt, { className: "list-item", role: "status", "aria-live": "assertive", children: p })
              ]
            }
          ) })
        ]
      }
    )
  ] }) });
};
T.Control = et;
T.Item = he;
T.Divider = ee;
T.Title = Qe;
export {
  T as D,
  He as S,
  he as a
};
